/*=========================================================================================
  File Name: moduleStaffActions.js
  Description: Staff Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Speed HRM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from "@/plugins/axios";


export default {



  async AddIngredients({ }, Credentials) {


    return new Promise((resolve, reject) => {
      axios
        .post("hms/ingredients", Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  GetIngredients({ }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("hms/ingredients/search", {
          params: {
            except: payload.except ? JSON.stringify(payload.except) : null,
            search: payload.query,
            limit: 100
          },
        })
        .then((resp) => {
          console.log("GetIngredients API Response Length:", resp.data.data.length);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  GetUnitTypes({ }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("units/search", {
          params: {
            except: payload.except ? JSON.stringify(payload.except) : null,
            search: payload.query,
            limit: 100
          },
        })
        .then((resp) => {
          console.log("GetUnitTypes API Response Length:", resp.data.data.length);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },


  async UploadIngredientImage({ }, Credentials) {
    console.log(Credentials.get("id"));
    return new Promise((resolve, reject) => {
      axios
        .post(`hms/ingredients/${Credentials.get("id")}/image-upload`, Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  async GetSinleIngredients({ }, Credentials) {

    return new Promise((resolve, reject) => {
      axios
        .get(`hms/ingredients/${Credentials}`)
        .then((resp) => {

          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  async UpdateIngredients({ }, Credentials) {

    let empid = Credentials.data.id;
    delete Credentials.data.id;
    return new Promise((resolve, reject) => {
      axios
        .patch(`hms/ingredients/${empid}`, Credentials.data)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },


};
